export default __webpack_public_path__ + "static/media/b1.95f6a817.jpg";